import React from 'react';
import RedirectLinkComponent from '../../../../Elements/RedirectLinkComponent';

// A third-party client invoice in the automatic invoicing History by its id, opening the invoice's details in a new
// tab as the job next to it does. A change without an invoice shows nothing.
export default function InvoiceAutomationInvoiceId({ tpClientInvoiceId = null }) {
  if (!tpClientInvoiceId) {
    return null;
  }

  return (
    <RedirectLinkComponent
      isFigmaStyle={true}
      path='tpclientinvoicedetails'
      tooltipText={tpClientInvoiceId}
      text={tpClientInvoiceId}
      keyValuePairs={[{ key: 'id', value: tpClientInvoiceId }]}
    />
  );
}
